import { Shield, TrendingUp, Landmark, Wallet } from "lucide-react";
import { useLang } from "@/LanguageContext";
import t from "@/translations";

export default function ArgumentsSection() {
  const { lang } = useLang();
  const tx = t[lang];

  const args = [
    { num: "01", icon: TrendingUp, title: tx.arg1_title, text: tx.arg1_text, hl: tx.arg1_hl },
    { num: "02", icon: Shield, title: tx.arg2_title, text: tx.arg2_text, hl: tx.arg2_hl },
    { num: "03", icon: Landmark, title: tx.arg3_title, text: tx.arg3_text, hl: tx.arg3_hl },
    { num: "04", icon: Wallet, title: tx.arg4_title, text: tx.arg4_text, hl: tx.arg4_hl },
  ];

  return (
    <section id="argumente" data-testid="arguments-section" className="py-16 sm:py-24 lg:py-32 bg-[#0C1620] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 sm:mb-16">
          <p className="uppercase text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.25em] text-[#C5993A] mb-3 sm:mb-4">{tx.args_tag}</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-5xl tracking-tight font-light text-white">{tx.args_h2}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8 lg:gap-12">
          {args.map((arg) => {
            const Icon = arg.icon;
            return (
              <div key={arg.num} data-testid={`argument-card-${arg.num}`} className="group relative bg-[#12202f] border border-[#3A4F60]/50 rounded-lg p-5 sm:p-8 lg:p-10 hover:-translate-y-1 hover:border-[#C5993A]/50 transition-all duration-300">
                <span className="absolute top-2 right-4 sm:top-4 sm:right-6 font-heading text-[80px] sm:text-[120px] leading-none text-[#3A4F60]/10 font-bold select-none pointer-events-none group-hover:text-[#C5993A]/10 transition-colors duration-500">{arg.num}</span>
                <div className="relative z-10">
                  <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-[#C5993A]/10 flex items-center justify-center">
                      <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-[#C5993A]" />
                    </div>
                    <span className="font-heading text-sm sm:text-lg text-[#C5993A] font-semibold">{arg.hl}</span>
                  </div>
                  <h3 className="font-heading text-lg sm:text-xl lg:text-2xl font-medium text-white mb-3 sm:mb-4">{arg.title}</h3>
                  <p className="text-[#8899AA] leading-relaxed text-xs sm:text-sm lg:text-base font-light">{arg.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
